module.exports = __webpack_public_path__ + "img/Hsse_page.41321fe2.jpeg";